import { render, staticRenderFns } from "./FabricComparisonDisclaimer.vue?vue&type=template&id=3f11b3ec&scoped=true&"
import script from "./FabricComparisonDisclaimer.vue?vue&type=script&lang=ts&"
export * from "./FabricComparisonDisclaimer.vue?vue&type=script&lang=ts&"
import style0 from "./FabricComparisonDisclaimer.vue?vue&type=style&index=0&id=3f11b3ec&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f11b3ec",
  null
  
)

export default component.exports